import { render } from "./HomeUploader.vue?vue&type=template&id=f1511640"
import script from "./HomeUploader.vue?vue&type=script&lang=js"
export * from "./HomeUploader.vue?vue&type=script&lang=js"
script.render = render

export default script